import { render, staticRenderFns } from "./LessonsView.vue?vue&type=template&id=50f8e089"
import script from "./LessonsView.vue?vue&type=script&lang=js"
export * from "./LessonsView.vue?vue&type=script&lang=js"
import style0 from "./LessonsView.vue?vue&type=style&index=0&id=50f8e089&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports